import {
  getPaymentIrkApi,
  getPaymentIrkPublicApi,
  getPaymentMelliApi,
} from "helpers/backend_helper"
import { takeEvery, put, call } from "redux-saga/effects"
import {
  getPaymentMelliFail,
  getPaymentIpgSuccess,
  paymentIpgReset,
} from "./actions"
import { GET_PAYMENT_IPG, GET_PAYMENT_IPG_PUBLIC } from "./actionTypes"

function* onGetPaymentIpg({ payload: values }) {
  try {
    let result = null
    if (values.gatewayTypeEnum === 4) {
      result = yield call(getPaymentIrkApi, { amount: values.amount })
    } else {
      result = yield call(getPaymentMelliApi, { amount: values.amount })
    }
    yield put(getPaymentIpgSuccess(result))
    yield put(paymentIpgReset())
    window.location.replace(result)
  } catch (error) {
    yield put(getPaymentMelliFail(error))
  }
}

function* onGetPaymentIpgPublic({ payload: values }) {
  try {
    const result = yield call(getPaymentIrkPublicApi, { ...values })
    yield put(getPaymentIpgSuccess(result))
    yield put(paymentIpgReset())
    window.location.replace(result)
  } catch (error) {
    yield put(getPaymentMelliFail(error))
  }
}

function* saga() {
  yield takeEvery(GET_PAYMENT_IPG, onGetPaymentIpg)
  yield takeEvery(GET_PAYMENT_IPG_PUBLIC, onGetPaymentIpgPublic)
}

export default saga
